export default __webpack_public_path__ + "static/media/mobilityAidBanner.58210505.png";